import React, { Suspense, useContext, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import lazyWithRetry from "../../utils/lazyWithRetry";

const AuthDialogs = lazyWithRetry(() => import("./AuthDialogs"));

// The login and password dialogs (AuthDialogs.jsx), fetched only once a page
// asks for one, through AuthContext or ?action=, so pages that never do
// don't load them. Once fetched they stay, so they can close in place.
export default function AuthDialogsWhenAsked() {
  const { isLoginOpen, isForgetPasswordOpen, isForgetPasswordResetOpen } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const asked = isLoginOpen || isForgetPasswordOpen || isForgetPasswordResetOpen || searchParams.has("action");
  const [wanted, setWanted] = useState(false);
  if (asked && !wanted) setWanted(true);
  return wanted ? <Suspense fallback={null}><AuthDialogs /></Suspense> : null;
}
